import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import AskKate, { RequestItem, markSeen, authHeaders } from '../AskKate';

const API = 'https://carriera-backend.onrender.com/api';

// "Ask Kate" page (candidate inventory Phase 2b): every request to Kate, newest
// first (GET /api/kate-requests, latest 100), plus a box for requests not about
// one candidate or job. Opening the page marks my replies read (sidebar badge).
const FILTERS = [
  { key: 'all',     label: 'All' },
  { key: 'open',    label: 'Waiting', test: r => ['waiting', 'working'].includes(r.status) },
  { key: 'replied', label: 'Replied', test: r => ['done', 'cannot_do'].includes(r.status) },
];

export default function KateRequests() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('all');

  const load = useCallback(() => {
    setError('');
    axios.get(`${API}/kate-requests`, { headers: authHeaders() })
      .then(({ data }) => { setRows(data); markSeen(data); })
      .catch(err => setError(err.response?.data?.error || 'Failed to load requests to Kate.'));
  }, []);

  useEffect(() => { load(); }, [load]);

  const test = FILTERS.find(f => f.key === filter).test;
  const shown = (rows || []).filter(r => !test || test(r));

  return (
    <div>
      <div className="flex items-end justify-between mb-6 gap-4">
        <div>
          <p className="text-xs font-medium text-carriera-muted uppercase tracking-widest mb-1">Recruitment</p>
          <h2 className="font-serif text-3xl font-normal text-carriera-text">Ask Kate</h2>
          <p className="text-sm text-carriera-muted mt-1">
            Requests to Kate and her replies. Ask about one candidate or job from its own page; ask anything else here.
          </p>
        </div>
        <button onClick={load}
          className="text-xs border border-carriera-border px-3 py-2 text-carriera-sec hover:border-carriera-accent transition-colors bg-white">
          Refresh
        </button>
      </div>

      <div className="bg-white border border-carriera-border p-5 mb-6" style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
        <p className="text-xs font-semibold text-carriera-muted uppercase tracking-widest mb-2">New general request</p>
        <AskKate aboutType="general" showHistory={false} onAsked={load}
          placeholder="e.g. Which live jobs have nobody on To Call yet?" />
      </div>

      <div className="flex gap-2 mb-3">
        {FILTERS.map(f => (
          <button key={f.key} onClick={() => setFilter(f.key)}
            className={`text-xs border px-3 py-1.5 transition-colors ${filter === f.key
              ? 'bg-carriera-text border-carriera-text text-white' : 'border-carriera-border text-carriera-sec hover:border-carriera-accent bg-white'}`}>
            {f.label}
          </button>
        ))}
      </div>

      {error ? <p className="text-sm text-red-600 py-8">{error}</p>
        : rows === null ? <p className="text-sm text-carriera-muted py-8">Loading...</p>
        : shown.length === 0 ? <p className="text-sm text-carriera-muted py-8">No requests here.</p>
        : (
          <div className="space-y-2 bg-white">
            {shown.map(r => <RequestItem key={r.id} r={r} showAbout />)}
          </div>
        )}
    </div>
  );
}
